import React from 'react';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { GradientMark, PageHeader, XpBadge } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentUi';
import { useStudent } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentContext';
import { STUDENT_BASE, shareTargets } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const AchievementDetail = () => {
  const { openSheet, showToast } = useStudent();

  return (
    <>
      <PageHeader
        title="Achievement Details"
        backTo={`${STUDENT_BASE}/achievements`}
        right={(
          <button type="button" className="sa-ib" aria-label="Share" onClick={openSheet}>
            <Icon name="share" />
          </button>
        )}
      />
      <div className="sa-shot">
        <Icon name="trophy" className="xl" />
      </div>
      <h2 className="sa-title-block">Won 2nd Prize – Inter-College Hackathon</h2>
      <div className="sa-mut sa-meta">
        <span><Icon name="camera" /> 3 photos</span>
        <span><Icon name="file" /> Certificate</span>
        <XpBadge amount={150} />
        <span><Icon name="cal" /> 12 Apr 2025</span>
      </div>
      <p className="sa-copy">
        Thrilled to have won 2nd prize at the Inter-College Hackathon! Learned a lot, met amazing people and can&apos;t wait for the next challenge.
      </p>
      <span className="sa-tag">Hackathon</span>
      <span className="sa-tag">Technology</span>
      <span className="sa-tag">Teamwork</span>

      <div className="sa-card sa-share-card">
        <div className="sa-b">Share Achievement</div>
        <div className="sa-mut">Show your success and inspire others!</div>
        <div className="sa-share">
          {shareTargets.map((target) => (
            <button key={target.label} type="button" onClick={() => showToast(`Shared to ${target.label}`)}>
              <GradientMark name={target.icon} from={target.color} to={target.color} />
              {target.label}
            </button>
          ))}
        </div>
      </div>
      <button type="button" className="sa-btn soft block" onClick={() => showToast('Card downloaded')}>
        <Icon name="dl" /> Download Card
      </button>
    </>
  );
};

export default AchievementDetail;
